// extracted by mini-css-extract-plugin
export default {"modalOverlay":"kM-z","modalContent":"lM-z","header":"mM-z","close":"nM-z"};